import { Router } from 'vue-router';
import { useTabStore, type Tab } from '@/store/tabs';

export function setupTabGuard(router: Router) {
  router.beforeEach((to, from, next) => {
    const tabsStore = useTabStore();

    // 如果是需要添加到標籤頁的路由
    if (to.meta?.addToTabs !== false && to.name && to.name !== 'login') {
      const tab: Tab = {
        id: to.path,
        title: String(to.meta?.title || to.name || to.path),
        path: to.path,
        icon: to.meta?.icon as string,
        closable: to.meta?.closable !== false
      };
      tabsStore.addTab(tab);
    }

    next();
  });
}
